<template>
    <div :class="theme.wrapper">
        <table :class="theme.table">
            <thead>
                <tr :class="theme.row">
                    <th v-if="extra" :class="theme.extraHead"></th>
                    <th
                        v-for="header, key, index in headers"
                        :class="[theme.head, {[theme.firstCell]: !index}]"
                        :key="key"
                    >
                        <div :class="getHeaderClasses(key)" @click="header.sort !== false && handleSort(key)">
                            
                            <slot :name="'head-' + key">
                                {{ header.label }}
                            </slot>
                            <v-font-icon v-if="isRenderSortIcon(key)" :class="classSortIcon(header.sort)">
                                arrow_downward
                            </v-font-icon>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loader"  :class="theme.row">
                    <td :class="theme.empty" :colspan="columnsCount">
                        <v-spinner block />
                    </td>
                </tr>
                <tr v-else-if="isEmptyRecords" :class="theme.row">
                    <td :class="theme.empty" :colspan="columnsCount">
                        <v-text>
                            {{ empty }}
                        </v-text>
                    </td>
                </tr>

                <template v-else>
                    <template v-for="record, index in records">
                        <tr
                            @click="handleClickRow(record)"
                            :class="classRow(record)"
                        >
                            <td v-if="extra">
                                <v-icon-button :class="classArrow(record)">
                                    keyboard_arrow_right
                                </v-icon-button>
                            </td>

                            <td
                                v-for="header, key, index in headers"
                                :class="[theme.cell, {[theme.firstCell]: !index}]"
                                :key="key"
                            >
                                <slot :name="'cell-' + key" :item="record">
                                    <v-text>
                                        {{ record[key] }}
                                    </v-text>
                                </slot>
                            </td>
                        </tr>

                        <tr
                            v-if="isRenderExtraRecord(record)"
                            :class="[theme.row, theme.isExtra]"
                        >
                            <td :colspan="columnsCount">
                                <slot name="extra" :item="record"></slot>
                            </td>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
    import { vAnimationHeight } from '../AnimationHeight';
    import { vSpinner } from '../Spinner';
    import { vText } from '../Typography';
    import { vFontIcon } from '../FontIcon';
    import theme from './dataTable.scss'

    export default {
        name: 'data-table',
        props: {
            extra: String, // multiple | single
            rowAction: Boolean,
            loader: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                },
            },
            headers: {
                type: Object,
                default() {
                    return {
                        id: {
                            sort: true,
                            label: 'ID',
                        },
                    };
                }
            },
            sort: {
                type: Object,
                default() {
                    return {
                        order: 'desc',
                        column: 'id'
                    };
                }
            },
            records: {
                type: Array,
                default() {
                    return [];
                }
            },
            empty: {
                type: String,
                default: 'Нет ни одной записи',
            }
        },
        components: {
            vFontIcon,
            vText,
            vSpinner,
            vAnimationHeight,
        },
        data() {
            return {
                isRenderExtraRecords: {
                    // [id]: boolean
                },
            };
        },
        computed: {
            isEmptyRecords() {
                return !this.records.length;
            },
            columnsCount() {
                const count = Object.keys(this.headers).length;

                return this.extra ? count + 1 : count;
            },
        },
        methods: {
            classArrow(record) {
                return {
                    [this.theme.arrow]: true,
                    [this.theme.isDown]: this.isRenderExtraRecord(record),
                }
            },
            classRow(record) {

                return {
                    [this.theme.row]: true,
                    [this.theme.isPointer]: Boolean(this.extra),
                    [this.theme.isPointer]: Boolean(this.rowAction),
                    [this.theme.isHover]: Boolean(this.rowAction),
                    [this.theme.isOpen]: this.isRenderExtraRecord(record),
                }
            },
            classSortIcon(hide) {
                return {
                    [this.theme.headerIcon]: true,
                    [this.theme.headerIconHide]: hide === false,
                }
            },
            isRenderExtraRecord(record) {
                if (!this.extra) {
                    return false;
                }

                return this.isRenderExtraRecords[record.id];
            },
            isRenderSortIcon(column) {
                return !this.$scopedSlots.hasOwnProperty('head-' + column);
            },
            getHeaderClasses(column) {
                return {
                    [this.theme.header]: true,
                    [this.theme.isAsc]: this.sort.order === 'asc',
                    [this.theme.isDesc]: this.sort.order === 'desc',
                    [this.theme.isActive]: this.sort.column === column,
                }
            },
            handleSort(column) {
                this.$emit('sort', {
                    order: this.sort.order === 'desc' ? 'asc' : 'desc',
                    column,
                })
            },
            handleClickRow(record) {
                if (this.rowAction) {
                    this.$emit('loadEvent', record.id)
                }

                if (!this.extra) {
                    return;
                }

                const isRenderExtraRecord = this.isRenderExtraRecords[record.id];

                if (this.extra === 'multiple') {
                    this.isRenderExtraRecords = {
                        ...this.isRenderExtraRecords,
                        [record.id]: !isRenderExtraRecord,
                    };
                } else {
                    this.isRenderExtraRecords = {
                        [record.id]: !isRenderExtraRecord,
                    };
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// DataTable.vue?5ea87379